import { Injectable } from '@angular/core';
import { userDtos } from '@vectronic/openApi-customer';
import { of } from 'rxjs';
import { TRAPS } from '../trap.mock';

@Injectable()
export class TrapEntityServiceMock {
  entities$ = of(TRAPS);

  getAll() {
    return of(TRAPS);
  }

  getFilteredItems() {
    return of(TRAPS);
  }
}

@Injectable()
export class TrapGroupEntityServiceMock {
  entities$ = of(TRAPS);

  getAll() {
    return of(Array<userDtos.Group>);
  }
}
